import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Building2, Sparkles } from 'lucide-react';

const VendorComparisonSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="How leading AI labs approach Chain-of-Thought reasoning"
      >
        Industry CoT Approaches: Overview
      </SlideTitle>
      
      <SlideContent>
        <div className="grid md:grid-cols-5 gap-4 mb-8">
          {[
            { name: 'DeepSeek', approach: 'Pure RL', color: 'primary', icon: '🇨🇳' },
            { name: 'OpenAI', approach: 'RLHF + Process', color: 'secondary', icon: '🇺🇸' },
            { name: 'Google', approach: 'Prompting', color: 'accent', icon: '🔍' },
            { name: 'Microsoft', approach: 'Synthetic Data', color: 'chart-4', icon: '💻' },
            { name: 'Alibaba', approach: 'Self-Improve', color: 'chart-5', icon: '🇨🇳' },
          ].map((vendor, index) => (
            <div key={index} className={`slide-card text-center border-${vendor.color}/30 hover:border-${vendor.color}/60 transition-all`}>
              <div className="text-2xl mb-2">{vendor.icon}</div>
              <div className="font-heading font-semibold text-foreground">{vendor.name}</div>
              <div className={`text-xs text-${vendor.color} mt-1`}>{vendor.approach}</div>
            </div>
          ))}
        </div>
        
        <div className="slide-card">
          <h3 className="font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" />
            Key Differentiators
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h4 className="text-sm font-semibold text-primary mb-2">Reward Mechanisms</h4>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>• <strong className="text-foreground">Outcome-based:</strong> Judge final answer only (DeepSeek)</li>
                <li>• <strong className="text-foreground">Process-based:</strong> Judge each step (OpenAI)</li>
                <li>• <strong className="text-foreground">Self-improvement:</strong> Iterative RM updates (Qwen)</li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-secondary mb-2">Training Philosophy</h4>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>• <strong className="text-foreground">Scale-first:</strong> Reasoning emerges at >100B params (Google)</li>
                <li>• <strong className="text-foreground">Data-first:</strong> Quality over quantity (Microsoft Phi)</li>
                <li>• <strong className="text-foreground">RL-first:</strong> Bypass human priors (DeepSeek)</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="mt-6 p-4 rounded-xl bg-primary/10 border border-primary/20">
          <p className="text-sm text-muted-foreground">
            <strong className="text-primary">Key Insight:</strong> Each vendor optimizes for different trade-offs between human supervision, compute efficiency, and emergent capabilities.
          </p>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default VendorComparisonSlide;
